import api from '~/api';
import { PartnerResponse } from '../dtos/contactResponse';
import { Contact } from '../models/contact.model';

export async function getContactInfo(partnerId: string): Promise<Contact> {
  const { data } = await api.get<PartnerResponse>(`v1/partner/${partnerId}`);
  return new Contact(
    `${data.tsm.first_name} ${data.tsm.last_name}`,
    data.tsm.email,
    data.tsm.phone_number
  );
}
